import NonEligibleArticleSection from './NonEligibleArticleSection';

export default NonEligibleArticleSection;
